import type {LayoutModelBranch} from '../../../types'
import {isChildOfStackContainer} from '../../common'
import {heightHeuristics, verticalSpacingHeuristics} from './heuristics'
import {verticalSpacingHeuristicsStack} from './stack'
import {rowHeuristicsFlush, rowHeuristicsAdaptive} from '../rowHeuristicsDefinitions'

export const heightTree: LayoutModelBranch[] = [{scope: () => true, heuristics: heightHeuristics}]

export const verticalSpacingTree: LayoutModelBranch[] = [
    {scope: isChildOfStackContainer, heuristics: verticalSpacingHeuristicsStack},
    {scope: () => true, heuristics: verticalSpacingHeuristics}
]

export const rowsFlushTree: LayoutModelBranch[] = [{scope: () => true, heuristics: rowHeuristicsFlush}]

export const rowsAdaptiveTree: LayoutModelBranch[] = [{scope: () => true, heuristics: rowHeuristicsAdaptive}]
